import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/laneeka/Navbar";
import Footer from "@/components/laneeka/Footer";
import Floating from "@/components/laneeka/Floating";
import AdminModal from "@/components/site/AdminModal";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import VisionPage from "@/pages/VisionPage";
import TeamPage from "@/pages/TeamPage";
import FootMapPage from "@/pages/FootMapPage";
import ProductsPage from "@/pages/ProductsPage";
import ContactPage from "@/pages/ContactPage";
import NewsPage from "@/pages/NewsPage";
import CareerPage from "@/pages/CareerPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Layout = () => {
  const [adminOpen, setAdminOpen] = useState(false);
  const navigate = useNavigate();
  return (
    <div className="App bg-white text-slate-900 antialiased" data-testid="app-root">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/foot-map" element={<FootMapPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/career" element={<CareerPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <Footer onAdmin={() => setAdminOpen(true)} />
      <Floating onQuote={() => navigate("/contact")} />
      <AdminModal open={adminOpen} onClose={() => setAdminOpen(false)} />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout />
    </BrowserRouter>
  );
}

export default App;
